import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Navbar2 from '../components/Navbar2';
import Footer from '../components/Footer';

function Layout({ children }) {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <>
      <a href="#main-content" className="skip-to-content">Skip to main content</a>
      {isHome ? <Navbar /> : <Navbar2 />}
      <main id="main-content">
        {children}
      </main>
      <Footer />
    </>
  );
}

export default Layout;
